import { useContext } from 'react';
import { Button } from 'reactstrap';
import { useParams } from 'react-router';
import { MapContext } from '../../../contexts/MapContext';

const FlipHeadlandButton = (buttonProps) => {
  const { farmId } = useParams();
  const {
    layers: { setLayerFeatureProperty },
    mapState: { activeLayerFeature, activeLayerFeatureId },
  } = useContext(MapContext);
  return (
    <Button
      onClick={() =>
        setLayerFeatureProperty(
          activeLayerFeatureId,
          farmId,
          'isInnerFeature',
          !activeLayerFeature.properties.isInnerFeature,
        )
      }
      {...buttonProps}
    >
      Flip
    </Button>
  );
};

export default FlipHeadlandButton;
